import { HttpParams } from '@angular/common/http';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type IHttpParamsType = Record<string, any>;

export const createHttpParams = (obj: IHttpParamsType): HttpParams => {
  let httpParams = new HttpParams(obj);
  for (const property in obj) {
    const val = obj[property];
    if (obj.hasOwnProperty(property) && typeof val !== 'undefined') {
      httpParams = httpParams.append(property, val);
    }
  }
  return httpParams;
};
